import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  margin-bottom: 10px;
`

export const Input = styled.input`
  appearance: none;
  cursor: pointer;
  border: 2px solid #dfe0e7;
  width: 20px;
  height: 20px;
  padding: 0;
  border-radius: 4px;

  &:checked {
    width: 20px;
    height: 20px;
    border: 0;
    background-color: #f3123c;
    background-image: url('/assets/img/icon/check-white.svg');
    background-position: center;
    background-repeat: no-repeat;
  }
`

export const Label = styled.label`
  font-size: 14px;
  line-height: 150%;
  color: #2e2d37;
  margin-left: 10px;
  width: 98%;
`
